module.exports = __webpack_public_path__ + "img/google-pay.a0cdbaf.svg";